import { Component, OnInit } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { ProductService } from '../../shared/services/product.service';
import { CartItem } from 'src/app/modals/cart-item';
import { CartService } from '../../shared/services/cart.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedMethods } from '../../shared/services/sharedMethods-service';



@Component({
  selector: 'app-home-four',
  templateUrl: './home-four.component.html',
  styleUrls: ['./home-four.component.sass']
})
export class HomeFourComponent implements OnInit {
  public banners = [];
  public infosbar = [];
  public currencies = ['USD', 'EUR'];
  public currency:any;
  public flags = [
    { name:'English', image: 'assets/images/flags/gb.svg' },
    { name:'German', image: 'assets/images/flags/de.svg' },
    { name:'French', image: 'assets/images/flags/fr.svg' },
    { name:'Russian', image: 'assets/images/flags/ru.svg' },
    { name:'Turkish', image: 'assets/images/flags/tr.svg' }
  ]
  public flag:any;

  products: Product[] = [];

  indexProduct: number;
  shoppingCartItems: CartItem[] = [];
  wishlistItems:   Product[] = [];
  categories: any[] = [];


  public slides = [];

  /* public slides = [
    { title: 'LIVRAISON GRATUITE', subtitle: 'Commande de plus de 50 000 F', image: 'assets/images/carousel/banner6.jpg' },
    { title: 'Biggest discount', subtitle: 'Check the promotion', image: 'assets/images/carousel/banner6.jpg' },
    { title: 'Biggest sale', subtitle: 'Dont miss it', image: 'assets/images/carousel/banner6.jpg' },
    { title: 'Our best products', subtitle: 'Special selection', image: 'assets/images/carousel/banner6.jpg' },
    { title: 'Massive sale', subtitle: 'Only for today', image: 'assets/images/carousel/banner6.jpg' }
  ]; */


  // tslint:disable-next-line:max-line-length
  constructor(private sharedMethods: SharedMethods, private productService: ProductService,  private cartService: CartService, private spinner: NgxSpinnerService) {
    this.cartService.getItems().subscribe(shoppingCartItems => this.shoppingCartItems = shoppingCartItems);

    if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {
        this.sharedMethods.cacheSettings = setting;
        this.infosbar = this.sharedMethods.cacheSettings.infosbar;
        this.slides = this.sharedMethods.cacheSettings.slides;
      });

    } else {

      this.infosbar = this.sharedMethods.cacheSettings.infosbar;
      this.slides = this.sharedMethods.cacheSettings.slides;

    }

  }

  ngOnInit() {

    /* this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 5000); */

    this.productService.getBanners()
    .subscribe(
      data => this.banners = data
    );


    if(this.productService.cacheProduct.length === 0) {

      this.spinner.show();

      this.productService.getProducts().subscribe((product: Product[]) => {

          this.productService.cacheProduct = product;
          this.products = this.productService.getPromotion(this.productService.cacheProduct);
          this.spinner.hide();

          this.categories =  this.productService.getCategories(this.productService.cacheProduct);

        }

      )

    } else {

      this.products = this.productService.getPromotion(this.productService.cacheProduct);
      this.categories =  this.productService.getCategories(this.productService.cacheProduct);
      // console.log(this.products);
    }

    this.currency = this.currencies[0];
    this.flag = this.flags[0];

}






nombrePair(nombre: number): boolean {

  if (nombre%2 === 0)
   return true;
  else
   return false
}





public changeCurrency(currency){
  this.currency = currency;
}
public changeLang(flag){
  this.flag = flag;
}

}
